/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Incode_TitleInputs */



/**
* | output |
* | --- |
* | "Video start timecode" |
*
* @param {Subtitle_Extract_Incode_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_incode_title = /** @type {((inputs?: Subtitle_Extract_Incode_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Incode_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code temporel de début de la vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video-Startzeitcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("timecode di inizio video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("таймкод начала видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo de inicio del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频开始时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画開始タイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो प्रारंभ समयकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo de início do vídeo")
	return /** @type {LocalizedString} */ ("Video start timecode")
});